__turbopack_context__.v({
  "className": "instrument_sans_ddb6a7a7-module__oZHZ1W__className",
  "variable": "instrument_sans_ddb6a7a7-module__oZHZ1W__variable",
});
